<template>
  <div>
    <transition enter-active-class="animated slideInRight" leave-active-class>
      <div class="editarDicom" v-if="mostrar">
        <AppFormCabecalho
          titulo="Editar informações DICOM"
          icon="mdi mdi-pencil"
        />
        <div class="editarDicom__conteudo">
          <table class="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th>Tag</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tag, idx) in tags" :key="idx">
                <td>{{ tag.label }}</td>
                <td>
                  <b-input-group size="sm" @dblclick="editar(tag)">
                    <date-picker
                      v-if="tag.date"
                      v-model="estudo[tag.val]"
                      lang="pt-br"
                      :type="tag.type"
                      :clearable="false"
                      :format="tag.format"
                      value-type="format"
                      input-class="col form-control"
                      placeholder
                      :disabled="!tag.edit"
                    ></date-picker>
                    <b-form-input
                      v-else
                      type="text"
                      :id="tag.val"
                      class="col"
                      v-model="estudo[tag.val]"
                      :ref="`tag-${idx}`"
                      :readonly="!tag.edit"
                      autocomplete="off"
                    />
                    <b-input-group-append>
                      <b-btn
                        variant="outline-secondary"
                        v-if="!tag.edit"
                        @click="editar(tag)"
                        title="Editar"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </b-btn>
                      <b-btn
                        variant="outline-secondary"
                        class="text-danger"
                        v-if="tag.edit"
                        @click="cancelarEdicao(tag)"
                        title="Cancelar"
                      >
                        <i class="mdi mdi-close-circle"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="editarDicom__footer">
          <button class="btn btn-sm btn-default" @click="fecharForm()">
            Cancelar
          </button>
          <button
            class="btn btn-sm btn-success float-lg-right"
            @click="salvarAlteracao()"
            :disabled="salvando"
          >
            <i
              class="mdi"
              :class="{
                'mdi-spin mdi-loading': salvando,
                'mdi-check-circle': !salvando
              }"
            ></i>
            Salvar Altera&ccedil;&otilde;es
          </button>
        </div>
      </div>
    </transition>
    <div class="editarDicom__backdrop" v-if="mostrar"></div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import EstudoApi from "../../api/estudoApi";

import AppFormCabecalho from "../layout/AppFormCabecalho.vue";

function tagsDefault() {
  return [
    { label: "Paciente ID", val: "pacienteID", edit: false },
    { label: "Descrição Estudo", val: "descricao", edit: false },
    { label: "Nome Paciente", val: "nomePaciente", edit: false },
    { label: "Núm. Acesso", val: "numeroAcesso", edit: false },
    {
      label: "Data Nascimento",
      val: "dataNascimento",
      edit: false,
      date: true,
      type: "date",
      format: "DD/MM/YYYY"
    },
    {
      label: "Data Estudo",
      val: "dataHoraEstudo",
      edit: false,
      date: true,
      type: "datetime",
      format: "DD/MM/YYYY HH:mm:ss"
    },
    {
      label: "Data Aquisição",
      val: "dataAquisicao",
      edit: false,
      date: true,
      type: "date",
      format: "DD/MM/YYYY"
    }
  ];
}

export default {
  name: "editarEstudoForm",
  components: { AppFormCabecalho, DatePicker },
  model: {
    prop: "mostrarForm",
    event: "change"
  },
  props: {
    mostrarForm: {
      type: Boolean,
      required: true,
      default: false
    },
    estudo: {
      type: Object
    }
  },
  data() {
    return {
      mostrar: false,
      salvando: false,
      tags: tagsDefault(),
      estudoEdit: {}
    };
  },
  watch: {
    mostrarForm(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this.mostrar = newVal;
      //Remove rolagem do body
      document.body.style.overflow = this.mostrar ? "hidden" : "";
      if (newVal) this.estudoEdit = { ...this.estudo };
    }
  },
  methods: {
    editar(tag) {
      const tagEdit = tag;
      const idx = this.tags.indexOf(tag);
      if (!tag.date) this.$refs[`tag-${idx}`][0].focus();
      tagEdit.edit = true;
    },
    cancelarEdicao(tag) {
      const tagEdit = tag;
      this.estudo[tag.val] = this.estudoEdit[tag.val];
      tagEdit.edit = false;
    },
    fecharForm() {
      this.mostrar = false;
      this.$emit("change", false);
      this.tags = tagsDefault();
    },
    escapeKeyListener(evt) {
      if (evt.keyCode === 27 && this.mostrar) {
        this.fecharForm();
      }
    },
    salvarAlteracao() {
      this.salvando = true;
      EstudoApi.alterar(this.estudo, JSON.stringify(this.estudoEdit))
        .then(() => {
          this.salvando = false;
          this.fecharForm();
        })
        .catch(() => {
          this.salvando = false;
        });
    }
  },
  created() {
    document.addEventListener("keyup", this.escapeKeyListener);
  },
  destroyed() {
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>
<style lang="scss" scoped>
.animated.slideInRight,
.animated.slideOutRight {
  animation-duration: 0.5s;
}
.editarDicom {
  position: fixed;
  width: 50%;
  top: 41px;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1041;
  border-left: 1px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  flex: 0;
  .wbs-form-header {
    padding: 10px 10px 0 10px;
  }
  @include element("conteudo") {
    padding: 10px;
    flex: 1;
  }
  @include element("footer") {
    padding: 10px;
    flex: 0;
    border-top: 1px solid #e3e3e3;
  }
}
.editarDicom__backdrop {
  opacity: 0.5;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
</style>
